// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-contact-dealer[data-v-63a6dc50] {\r\n  background-color: var(--carbon-900) !important;\n}\n.btn-contact-dealer[data-v-63a6dc50]:hover {\r\n  background-color: var(--carbon-800) !important;\n}\n.btn-contact-dealer[data-v-63a6dc50]:pressed {\r\n  background-color: var(--black) !important;\n}\n.btn-contact-support[data-v-63a6dc50] {\r\n  border: 2px solid var(--black) !important;\r\n  border-radius: 500px;\r\n  color: var(--black) !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
